import { render, staticRenderFns } from "./PlateUpdate2.vue?vue&type=template&id=2c726510&scoped=true&"
import script from "./PlateUpdate2.vue?vue&type=script&lang=js&"
export * from "./PlateUpdate2.vue?vue&type=script&lang=js&"
import style0 from "./PlateUpdate2.vue?vue&type=style&index=0&id=2c726510&prod&scoped=true&lang=css&"
import style1 from "./PlateUpdate2.vue?vue&type=style&index=1&id=2c726510&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c726510",
  null
  
)

export default component.exports